/***
 *
 * @file components/Select/index.tsx
 * @description Select component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Truminds Software System
 * @since 13 Feb 2024
 *
 */

import React from "react";
// import "./Select.scss";
import classNames from 'classnames';
// import { useContentfulInspectorMode, useContentfulLiveUpdates } from "@contentful/live-preview/react";

type T_Props = {
  id?: string | undefined,
  className?: string,
  typeid?: string,
  data: any,
}

/**
 * Description: a functional component that takes in dropdownContent options and renders a dropdown
 * @param param0 object containing typeid and data
 * @example T_Props
 * ```
 * type T_Props = {
 *    typeid?: string,    // optional
 *    data: any           
 * }
 * ```
 * @returns 
 */

const Select = ({ id="", className="", typeid = "", data = {} }: T_Props) => {
  const dropdownContent = data?.content?.dropdown; //useContentfulLiveUpdates(data?.content?.dropdown);
  // const inspectorModeProps = useContentfulInspectorMode();
  
  return (
    <div 
      // {...inspectorModeProps({fieldId: dropdownContent?.contentType || "baseplateSection", entryId: dropdownContent?.id})} 
      className="Select-container" data-testid="Select">
      {/* {JSON?.stringify(dropdownContent, null, 2)} */}
      <label htmlFor={`dropdown-${dropdownContent?.id}`} className="form-control-label">{dropdownContent?.content?.label}</label>
      <select
        name={dropdownContent?.content?.name}
        className={classNames((dropdownContent?.contentType || ""), className) }
        id={dropdownContent?.content?.id || dropdownContent?.content?.name || `dropdown-${dropdownContent?.id}`}
      >
        {
          dropdownContent?.content?.options && dropdownContent?.content?.options?.map((optionItem: string, index: number) => {
            return <option key={`select-option-${index}-${(new Date()).getTime()}`} value={optionItem}>{optionItem}</option>
          })
        }
      </select>
    </div>
  );
};

export default Select;
